import React, { Component } from 'react';
import Select from '../../../Part_Sample/Select';

export default class Delay extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		return (
			<div id='delay' style={this.props.container_style}>
				<div style={{}}>
					<span className="header">{this.props.receiver.getString('delay_settings')}</span>
				</div>
				<div id='win_delay' style={this.props.container_item_style}>
					<div style={{ display: 'inline-block', width: this.props.width - 220, verticalAlign: 'top' }}>
						<span className='title' style={{ fontSize: 18 }}>{this.props.receiver.getString('win_delay')}</span>
					</div>
					<div style={{ display: 'inline-block', width: 150 }}>
						<Select
							select_style={{ fontSize: 20, height: 35 }}
							options={this.props.win_delay_range}
							value={this.props.ctrl_param.win_delay}
							onSelect={this.props.handleChangeWinDelay}
						/>
					</div>
				</div>
				<div id='unocc_delay' style={this.props.container_item_style}>
					<div style={{ display: 'inline-block', width: this.props.width - 220, verticalAlign: 'top' }}>
						<span className='title' style={{ fontSize: 18 }}>{this.props.receiver.getString('unocc_delay')}</span>
					</div>
					<div style={{ display: 'inline-block', width: 150 }}>
						<Select
							select_style={{ fontSize: 20, height: 35 }}
							options={this.props.unocc_delay_range}
							value={this.props.ctrl_param.unocc_delay}
							onSelect={this.props.handleChangeUnoccDelay}
						/>
					</div>
				</div>
			</div>
		)
	}
}